// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1hiAK","checkboxCol":"Table_checkboxCol__1JsVq","emailCol":"Table_emailCol__-S8uT","actionCol":"Table_actionCol__15qPr"};